/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentParcelsParcelidCancelMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidCancelPathParams,
  PostApiV1IndividualpaymentParcelsParcelidCancel401,
  PostApiV1IndividualpaymentParcelsParcelidCancel404,
  PostApiV1IndividualpaymentParcelsParcelidCancel500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidCancel.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentParcelsParcelidCancel } from "../../clients/individualPaymentOperationsController/postApiV1IndividualpaymentParcelsParcelidCancel.ts";

export const postApiV1IndividualpaymentParcelsParcelidCancelMutationKey = () =>
  [{ url: "/api/v1/individualpayment/parcels/:parcelId/cancel" }] as const;

export type PostApiV1IndividualpaymentParcelsParcelidCancelMutationKey =
  ReturnType<typeof postApiV1IndividualpaymentParcelsParcelidCancelMutationKey>;

export function postApiV1IndividualpaymentParcelsParcelidCancelMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1IndividualpaymentParcelsParcelidCancelMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentParcelsParcelidCancelMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidCancel401
      | PostApiV1IndividualpaymentParcelsParcelidCancel404
      | PostApiV1IndividualpaymentParcelsParcelidCancel500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelPathParams["parcelId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ parcelId }) => {
      return postApiV1IndividualpaymentParcelsParcelidCancel(parcelId, config);
    },
  });
}

/**
 * @description Migrado do legado IndividualPayment/CancelParcel. **(Requer Authorization para autenticação)**
 * @summary Cancela uma parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/cancel}
 */
export function usePostApiV1IndividualpaymentParcelsParcelidCancel<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidCancelMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidCancel401
        | PostApiV1IndividualpaymentParcelsParcelidCancel404
        | PostApiV1IndividualpaymentParcelsParcelidCancel500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelPathParams["parcelId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentParcelsParcelidCancelMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentParcelsParcelidCancelMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidCancelMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidCancel401
        | PostApiV1IndividualpaymentParcelsParcelidCancel404
        | PostApiV1IndividualpaymentParcelsParcelidCancel500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelPathParams["parcelId"];
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentParcelsParcelidCancelMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidCancel401
      | PostApiV1IndividualpaymentParcelsParcelidCancel404
      | PostApiV1IndividualpaymentParcelsParcelidCancel500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelPathParams["parcelId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentParcelsParcelidCancelMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidCancel401
      | PostApiV1IndividualpaymentParcelsParcelidCancel404
      | PostApiV1IndividualpaymentParcelsParcelidCancel500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelPathParams["parcelId"];
    },
    TContext
  >;
}
